import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {contentTypeToName} from '../../../../../utils/content/content-type-to-name.utils';
import {PrismConfigOptions} from '../../../../environment-variables/environment-variables.interface';
import {EnvVariables} from '../../../../environment-variables/environment-variables.token';
import {TemplateEntity} from './entities/template.entity';

/**
 * Component for the listing page template modal
 * @class TemplateModalComponent
 */
@Component({
  selector: 'advtech-template-modal',
  templateUrl: './template-modal.component.html',
})
export class TemplateModalComponent {

  /**
   * The content type
   */
  contentType: string;

  /**
   * Title for the modal
   */
  title: string;

  /**
   * The templates to display
   */
  templates: TemplateEntity[];

  /**
   * Reference to the fileUpload element
   * @type ElementRef
   * @private
   */
  @ViewChild('fileUpload')
  private fileUpload: ElementRef;

  /**
   * used to store selected template while video file is selected
   */
  private selectedTemplate: TemplateEntity;

  constructor(private params: NavParams, private viewCtrl: ViewController, @Inject(EnvVariables) public envVariables: PrismConfigOptions) {
    this.contentType = this.params.get('contentType');
    this.templates = [this.getBlankTemplate()].concat(this.params.get('templates'));
    this.title = `Create ${contentTypeToName(this.contentType)}`;
  }

  /**
   * Fires when a user selects a template
   * @param {TemplateEntity} template Template entity instance
   * @return {Promise}
   */
  selectTemplate(template: TemplateEntity) {
    if (this.contentType === 'content_video' && this.envVariables.enabledContentFeatures.video.upload) {
      this.launchVideoFilePicker();
      this.selectedTemplate = template;
    }
    else {
      return this.viewCtrl.dismiss({status: 'templateSelected', template: template});
    }
  }

  /**
   * @param {any} event from picker
   * @returns {any}
   */
  hFileChange(event: any): any {
    return this.viewCtrl.dismiss({status: 'templateSelected', template: this.selectedTemplate, files: event.target.files});
  }

  /**
   * Dismisses the modal
   * @return {Promise}
   */
  dismiss() {
    return this.viewCtrl.dismiss({status: 'cancel'});
  }

  /**
   * launch native video file picker
   * @returns {void}
   */
  private launchVideoFilePicker(): void {
    this.fileUpload.nativeElement.click();
  }

  /**
   * generate a blank template
   * @returns {TemplateEntity}
   */
  private getBlankTemplate(): TemplateEntity {
    return new TemplateEntity({
      data: {
        id: 'blank',
        contentType: this.contentType,
        name: '*Blank ' + contentTypeToName(this.contentType),
      },
      id: 'blank',
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/template-modal/template-modal.component.ts